export const UPDATE_FILTER = 'UPDATE_FILTER'
export const GET_SALES_EVENTS_REQUESTED = 'GET_SALES_EVENTS_REQUESTED'
export const GET_SALES_EVENTS_SUCCEEDED = 'GET_SALES_EVENTS_SUCCEEDED'
export const GET_SALES_EVENTS_FAILED = 'GET_SALES_EVENTS_FAILED'

export const UPDATE_SALES_EVENT_REQUESTED = 'UPDATE_SALES_EVENT_REQUESTED'
export const UPDATE_SALES_EVENT_SUCCEEDED = 'UPDATE_SALES_EVENT_SUCCEEDED'
export const UPDATE_SALES_EVENT_FAILED = 'UPDATE_SALES_EVENT_FAILED'
